import PlanningSection from '@bridebook/web/app-basic/components/articles/articles-sidebar-section/planning-section';
import BlockArticle from '@bridebook/web/app-basic/components/blocks/block-article';
import { getArticle, getRelatedArticles } from '@bridebook/web/app-basic/lib/article/selectors';
import { toArticleCard } from '@bridebook/web/app-shared/lib/articles/to-article-card';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useTranslation } from 'next-i18next';
import Router from 'next/router';
import { ChangeEvent } from 'react';
import { Box, RadioToggle } from '@bridebook/ui';
import AppAdComponent from '@bridebook/web/app-shared/components/articles/app-ad/app-ad';
import SidebarSection from '@bridebook/web/app-shared/components/articles/sidebar-section/sidebar-section';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { getTagsList } from '@bridebook/web/app-shared/lib/articles/utils';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import componentStyles from './articles-sidebar-section.style';

const ArticlesSidebarSection = () => {
  const { t } = useTranslation('articles');
  const market = useMarket();
  const relatedArticles = useSelector(getRelatedArticles);
  const article = useSelector(getArticle);

  const tagsList = getTagsList(article);

  const styles = componentStyles();

  const getArticleTagLink = (tagSlug?: string) =>
    `/${market.prefix}${UrlHelper.advice}${tagSlug ? '/' + tagSlug : ''}`;

  const onTagClick = (e?: ChangeEvent<HTMLInputElement>) => {
    const newTag = e?.target.value;
    Router.push(getArticleTagLink(newTag), undefined, {
      shallow: true,
      scroll: false,
    });
  };

  return (
    <Box>
      {!!relatedArticles?.length && (
        <SidebarSection title={t('relatedArticles')}>
          {relatedArticles?.map((article, i) => (
            <BlockArticle
              key={article.ID}
              size={i === 0 ? 'medium' : 'small'}
              article={toArticleCard(article)}
              index={i}
            />
          ))}
        </SidebarSection>
      )}
      {tagsList.length > 0 && (
        <Box px={6} mt={1}>
          <Box style={styles.topics}>{t('browse.topics')}</Box>
          <Box style={styles.tagsWrap}>
            {tagsList.map((tag, i) => (
              <Link key={`href-${i}`} href={getArticleTagLink(tag.slug)}>
                <RadioToggle
                  key={`toggle-${i}`}
                  name="topic"
                  id={`article-tag-${tag.slug}`}
                  value={tag.slug}
                  onChange={onTagClick}
                  label={tag.name}
                  color="#1A2C40"
                  noBorder
                />
              </Link>
            ))}
          </Box>
        </Box>
      )}
      <Box style={styles.adWrapper}>
        <AppAdComponent />
      </Box>
      <Box style={styles.planWrapper}>
        <PlanningSection />
      </Box>
    </Box>
  );
};

export default ArticlesSidebarSection;
